import React,{Component } from 'react';
import {Link} from 'react-router';

const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class Order_aborted extends Component{
	constructor(props){
		super(props);
		this.state={
			status_title:'Something went wrong',
		}
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
		    window.location.href="/web/status/"+this.props.params.Type;
		}
	}
	render(){
		var status_title = 'Something went wrong';
		if(this.props.params.Type === 'aborted')
		{
			status_title = 'Transaction Aborted';
		}
		else if(this.props.params.Type ==='failure')
		{
			status_title= 'Transaction Failed';
		}
		else if(this.props.params.Type ==='invalid')
		{
			status_title= 'Invalid Transaction';
		}
		else if(this.props.params.Type === 'serverDown')
		{
			status_title= 'Server Down';
		}
		return(
			<div className="mob_deals order_aborted_page">
			    <div className="page_hdr">
			      <div className="container-fluid">
			        <h5><a href={'/mycart'}><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=""/></i></a>Confirmation</h5>
			        <a href="/" title="Home" className="home_logo1"><img src={baseAssets+'images/web_imgs/home1.png'} alt="Home" /></a>
			      </div>
			    </div>
			    <div className="pag_cntnt">&nbsp;</div>

			    <div className="abort_content">
			    	{status_title ? <h4>{status_title}</h4> : <h4>Something went wrong</h4>}
			    	<a href={'/mycart'} className="try_again_btn">Try again</a>
			    </div>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Cart/Order_aborted.js
 **/